import { Testimonial } from '@rumblefish/ui/src/components/Rumblefish23Theme';

import alainPrasquierAvatar from '../../../public/webp/fromPNG/AlgeaTheme/revelator/alain-prasquier-avatar.webp';
import { StyledSection } from './styles';
import { StaticImageData } from 'next/image';

export const TestimonialSection = () => {
  return (
    <StyledSection width="small" mt={10}>
      <Testimonial
        name="Alain Prasquier"
        positionInCompany="CTO of Revelator"
        text={`
          We have been greatly satisfied with the services provided by
          Rumble Fish. Their team is friendly, knowledgeable, creative, and
          committed to helping us create a complex, blockchain-based royalty
          payment system. We are very thankful for their dedication and hard
          work
          `}
        avatarSrc={(alainPrasquierAvatar as unknown as StaticImageData)?.src}
        customStyles={{
          height: '424px',
          display: 'flex',
          justifyContent: 'center',
        }}
      />
    </StyledSection>
  );
};
